var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJaugeComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 78.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1 {\r\n                fill: url(#D\xE9grad\xE9_sans_nom_33);\r\n            }\r\n\r\n            .cls-2 {\r\n                fill: url(#D\xE9grad\xE9_sans_nom_15);\r\n            }\r\n\r\n            .cls-3,\r\n            .cls-5,\r\n            .cls-7,\r\n            .cls-9 {\r\n                fill: none;\r\n                stroke-miterlimit: 10;\r\n            }\r\n\r\n            .cls-3 {\r\n                stroke: #fff;\r\n                stroke-width: 1.19px;\r\n            }\r\n\r\n            .cls-4 {\r\n                fill: #21bbee;\r\n            }\r\n\r\n            .cls-5,\r\n            .cls-7,\r\n            .cls-9 {\r\n                stroke-width: 2px;\r\n            }\r\n\r\n            .cls-5 {\r\n                stroke: url(#D\xE9grad\xE9_sans_nom_2);\r\n            }\r\n\r\n            .cls-6 {\r\n                fill: #fff;\r\n            }\r\n\r\n            .cls-7 {\r\n                stroke: url(#D\xE9grad\xE9_sans_nom_2-2);\r\n            }\r\n\r\n            .cls-8 {\r\n                fill: #1c2057;\r\n            }\r\n\r\n            .cls-9 {\r\n                stroke: url(#D\xE9grad\xE9_sans_nom_2-3);\r\n            }\r\n\r\n            .cls-10 {\r\n                fill: url(#D\xE9grad\xE9_sans_nom_33-2);\r\n            }\r\n\r\n            .cls-11 {\r\n                fill: #1f93b2;\r\n            }\r\n\r\n            .cls-12 {\r\n                fill: #17243f;\r\n            }\r\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33",
    x1: 250,
    y1: 35.23,
    x2: 250,
    y2: 55.03,
    gradientTransform: "translate(204.68 295.32) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17243e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_15",
    x1: 3730.4,
    y1: 45.06,
    x2: 4223.12,
    y2: 45.06,
    gradientTransform: "matrix(-1, 0, 0, 1, 4225.91, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f5fbfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#d9eff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#adddf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6fc3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#21a2d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#20a2d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1e70a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1d457b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#1c2a61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c2057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_2",
    x1: 231.2,
    y1: -2818.5,
    x2: 268.2,
    y2: -2818.5,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -2800)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_2-2",
    x1: 451.56,
    y1: -2818.5,
    x2: 488.56,
    y2: -2818.5,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -2800)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_2-3",
    x1: 11.72,
    y1: -2818.5,
    x2: 48.72,
    y2: -2818.5,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -2800)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2_lyc\\xE9en",
    "data-name": "V2 lyc\\xE9en"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 240,
    y: -204.68,
    width: 20,
    height: 500,
    rx: 9,
    transform: "translate(295.32 -204.68) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.84,51.82c5.8,0,10.52-3,10.52-6.76s-4.72-6.77-10.52-6.77H14.16c-5.8,0-10.52,3-10.52,6.77s4.72,6.76,10.52,6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.16,52.09c-5.8,0-10.52-3-10.52-6.77s4.72-6.76,10.52-6.76H485.84c5.8,0,10.52,3,10.52,6.76s-4.72,6.77-10.52,6.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.16,19.45a11.11,11.11,0,0,0,2.95-7.56,10.42,10.42,0,1,0-20.82,0,11.08,11.08,0,0,0,3,7.57A18.35,18.35,0,0,0,232.2,36h35A18.38,18.38,0,0,0,257.16,19.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.16,19.45a11.11,11.11,0,0,0,2.95-7.56,10.42,10.42,0,1,0-20.82,0,11.08,11.08,0,0,0,3,7.57A18.35,18.35,0,0,0,232.2,36h35A18.38,18.38,0,0,0,257.16,19.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-3",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2-2",
    "data-name": "Calque 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M477.52,19.45a11.11,11.11,0,0,0,3-7.56,10.42,10.42,0,1,0-20.82,0,11.08,11.08,0,0,0,3,7.57,18.35,18.35,0,0,0-10,16.54h35A18.38,18.38,0,0,0,477.52,19.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M477.52,19.45a11.11,11.11,0,0,0,3-7.56,10.42,10.42,0,1,0-20.82,0,11.08,11.08,0,0,0,3,7.57,18.35,18.35,0,0,0-10,16.54h35A18.38,18.38,0,0,0,477.52,19.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-4",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2-3",
    "data-name": "Calque 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M37.68,19.45a11.11,11.11,0,0,0,3-7.56A10.65,10.65,0,0,0,30.22,1,10.65,10.65,0,0,0,19.81,11.89a11.08,11.08,0,0,0,3,7.57A18.35,18.35,0,0,0,12.72,36h35A18.38,18.38,0,0,0,37.68,19.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.68,19.45a11.11,11.11,0,0,0,3-7.56A10.65,10.65,0,0,0,30.22,1,10.65,10.65,0,0,0,19.81,11.89a11.08,11.08,0,0,0,3,7.57A18.35,18.35,0,0,0,12.72,36h35A18.38,18.38,0,0,0,37.68,19.45Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 249.59,
    cy: 45.08,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.59,
    cy: 45.08,
    r: 7,
    fill: "url(#D\\xE9grad\\xE9_sans_nom_33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M255.93,45.08a6.35,6.35,0,1,1-6.34-6.34A6.34,6.34,0,0,1,255.93,45.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M231.27,78a5,5,0,0,1-2.37-1.72l1.46-1.5a3.46,3.46,0,0,0,1.7,1.33,6.61,6.61,0,0,0,2.12.31,3.39,3.39,0,0,0,2.24-.68,2.67,2.67,0,0,0,0-3.88,4.31,4.31,0,0,0-2.53-.62,12.12,12.12,0,0,0-2.8.38l-1.34-1.56.56-5.88H239v2h-6.62l-.26,3.14a9,9,0,0,1,1.74-.16,7.11,7.11,0,0,1,4.44,1.21,4.2,4.2,0,0,1,1.54,3.49,4.07,4.07,0,0,1-1.51,3.34,6.45,6.45,0,0,1-4.15,1.22A9.47,9.47,0,0,1,231.27,78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M243.36,77.05A5.43,5.43,0,0,1,242,73.12V69a5.13,5.13,0,1,1,10.24,0v4.08A5.43,5.43,0,0,1,251,77.05a6,6,0,0,1-7.6,0ZM249,75.57a4,4,0,0,0,.65-2.45V69a3.6,3.6,0,0,0-.65-2.3,2.29,2.29,0,0,0-1.87-.8,2.27,2.27,0,0,0-1.87.8,3.54,3.54,0,0,0-.65,2.3v4.08a3.93,3.93,0,0,0,.65,2.45,2.19,2.19,0,0,0,1.87.85A2.22,2.22,0,0,0,249,75.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M254.92,71.2a3.13,3.13,0,0,1-.84-2.36V66.38a2.94,2.94,0,0,1,.84-2.26,3.49,3.49,0,0,1,2.44-.78,3.42,3.42,0,0,1,2.4.79,2.92,2.92,0,0,1,.86,2.25v2.46a3.11,3.11,0,0,1-.86,2.35,3.26,3.26,0,0,1-2.4.83A3.37,3.37,0,0,1,254.92,71.2Zm3.45-1.11a2,2,0,0,0,.34-1.25V66.38a1.71,1.71,0,0,0-.34-1.14,1.27,1.27,0,0,0-1-.4,1.29,1.29,0,0,0-1,.4,1.61,1.61,0,0,0-.37,1.14v2.46a1.85,1.85,0,0,0,.37,1.25,1.25,1.25,0,0,0,1,.43A1.23,1.23,0,0,0,258.37,70.09Zm7.95-5.91h1.81l-8.35,14H258Zm0,13.9a3.1,3.1,0,0,1-.86-2.36V73.26a2.92,2.92,0,0,1,.86-2.26,4.12,4.12,0,0,1,4.84,0,3,3,0,0,1,.84,2.25v2.46a3.14,3.14,0,0,1-.84,2.35,4,4,0,0,1-4.84,0ZM269.76,77a1.88,1.88,0,0,0,.36-1.25V73.26a1.66,1.66,0,0,0-.36-1.14,1.27,1.27,0,0,0-1-.4,1.3,1.3,0,0,0-1,.4,1.66,1.66,0,0,0-.36,1.14v2.46a1.88,1.88,0,0,0,.36,1.25,1.23,1.23,0,0,0,1,.43A1.2,1.2,0,0,0,269.76,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M16.65,74.94a4.87,4.87,0,0,1-1-3.35V68.22a4.68,4.68,0,0,1,1-3.28,3.92,3.92,0,0,1,3-1.12,3.92,3.92,0,0,1,3,1.13,4.62,4.62,0,0,1,1.05,3.27v3.37a4.82,4.82,0,0,1-1.05,3.35,3.86,3.86,0,0,1-3,1.15A3.86,3.86,0,0,1,16.65,74.94Zm5-.87a4,4,0,0,0,.66-2.48V68.22a3.77,3.77,0,0,0-.66-2.4A2.32,2.32,0,0,0,19.69,65a2.32,2.32,0,0,0-1.92.83,3.77,3.77,0,0,0-.66,2.4v3.37a4,4,0,0,0,.66,2.48,2.27,2.27,0,0,0,1.92.85A2.27,2.27,0,0,0,21.61,74.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M26.17,70a2.79,2.79,0,0,1-.65-2V66A2.72,2.72,0,0,1,26.17,64a2.6,2.6,0,0,1,1.92-.67A2.58,2.58,0,0,1,30,64,2.67,2.67,0,0,1,30.65,66v2A2.75,2.75,0,0,1,30,70a2.51,2.51,0,0,1-1.91.69A2.53,2.53,0,0,1,26.17,70Zm3-.66A2.08,2.08,0,0,0,29.52,68V66a2,2,0,0,0-.37-1.28,1.5,1.5,0,0,0-2.13,0A1.91,1.91,0,0,0,26.64,66v2A2,2,0,0,0,27,69.29a1.47,1.47,0,0,0,2.13,0ZM35.82,64h1.11L29.82,75.91h-1.1Zm-.33,11.81a2.75,2.75,0,0,1-.65-2v-2a2.67,2.67,0,0,1,.65-2,3.07,3.07,0,0,1,3.83,0,2.72,2.72,0,0,1,.65,2v2a2.79,2.79,0,0,1-.65,2,3,3,0,0,1-3.83,0Zm3-.66a2.08,2.08,0,0,0,.36-1.32v-2a2,2,0,0,0-.36-1.29,1.53,1.53,0,0,0-2.14,0A1.93,1.93,0,0,0,36,71.81v2a2,2,0,0,0,.37,1.31,1.49,1.49,0,0,0,2.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M453.55,64V75.91h-1.49V65.4L449.39,67V65.62L452.14,64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M457.55,74.94a4.87,4.87,0,0,1-1-3.35V68.22a4.68,4.68,0,0,1,1-3.28,4.67,4.67,0,0,1,6.08,0,4.67,4.67,0,0,1,1,3.27v3.37a4.87,4.87,0,0,1-1,3.35,4.59,4.59,0,0,1-6.08,0Zm5-.87a4,4,0,0,0,.66-2.48V68.22a3.77,3.77,0,0,0-.66-2.4,2.64,2.64,0,0,0-3.84,0,3.77,3.77,0,0,0-.66,2.4v3.37a4,4,0,0,0,.66,2.48,2.59,2.59,0,0,0,3.84,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M467.82,74.94a4.82,4.82,0,0,1-1-3.35V68.22a4.63,4.63,0,0,1,1-3.28,4.66,4.66,0,0,1,6.07,0,4.62,4.62,0,0,1,1.05,3.27v3.37a4.82,4.82,0,0,1-1.05,3.35,4.58,4.58,0,0,1-6.07,0Zm5-.87a4,4,0,0,0,.66-2.48V68.22a3.77,3.77,0,0,0-.66-2.4,2.64,2.64,0,0,0-3.84,0,3.77,3.77,0,0,0-.67,2.4v3.37a4,4,0,0,0,.67,2.48,2.59,2.59,0,0,0,3.84,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M477.34,70a2.79,2.79,0,0,1-.65-2V66a2.72,2.72,0,0,1,.65-1.95,3.07,3.07,0,0,1,3.83,0,2.72,2.72,0,0,1,.65,1.95v2a2.79,2.79,0,0,1-.65,2,3,3,0,0,1-3.83,0Zm3-.66a2.08,2.08,0,0,0,.36-1.32V66a2,2,0,0,0-.36-1.28,1.31,1.31,0,0,0-1.06-.44,1.29,1.29,0,0,0-1.07.45,1.91,1.91,0,0,0-.38,1.27v2a2,2,0,0,0,.38,1.31,1.27,1.27,0,0,0,1.07.46A1.29,1.29,0,0,0,480.32,69.3ZM487,64h1.11L481,75.91h-1.11Zm-.33,11.81a2.75,2.75,0,0,1-.66-2v-2a2.68,2.68,0,0,1,.66-2,3.06,3.06,0,0,1,3.82,0,2.68,2.68,0,0,1,.66,2v2a2.75,2.75,0,0,1-.66,2,3,3,0,0,1-3.82,0Zm3-.66a2,2,0,0,0,.37-1.32v-2a1.93,1.93,0,0,0-.37-1.29,1.32,1.32,0,0,0-1.06-.43,1.34,1.34,0,0,0-1.07.44,1.93,1.93,0,0,0-.37,1.28v2a2,2,0,0,0,.37,1.31,1.3,1.3,0,0,0,1.07.46A1.27,1.27,0,0,0,489.63,75.15Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaugeComplete);
export default __webpack_public_path__ + "static/media/jauge_complete.e9f964ef61b8c725f5a2f95eaa04a4bb.svg";
export { ForwardRef as ReactComponent };